const childRoute = (prop) => [
    {
    path: 'crop-type',
    name: prop + '.crop_type',
    meta: { auth: true },
    component: () => import('../pages/crop-type/List.vue')
  },
  {
    path: 'seed-crop',
    name: prop + '.seed_crop',
    meta: { auth: true },
    component: () => import('../pages/seed-crop/List.vue')
  },
  {
    path: 'seed-variety',
    name: prop + '.seed_variety',
    meta: { auth: true },
    component: () => import('../pages/seed-variety/List.vue')
  },
  {
    path: 'variety-pricing',
    name: prop + '.variety_pricing',
    meta: { auth: true },
    component: () => import('../pages/variety-pricing/List.vue')
  },
  {
    path: 'variety-assignment',
    name: prop + '.variety_assignment',
    meta: { auth: true },
    component: () => import('../pages/variety-assignment/List.vue')
  },
  {
    path: 'activity',
    name: prop + '.activity',
    meta: { auth: true },
    component: () => import('../pages/activity/List.vue')
  },
   {
    path: 'office-mapping',
    name: prop + '.office_mapping',
    meta: { auth: true },
    component: () => import('../pages/office-mapping/List.vue')
  },
  {
    path: 'time-bound',
    name: prop + '.time_bound',
    meta: { auth: true },
    component: () => import('../pages/time-bound/List.vue')
  }
]
const routes = [
  {
    path: '/seeds-fertilizer-service/seeds-badc-configuration',
    name: 'seeds_fertilizer_service.seeds-badc-configuration',
    component: () => import('@/layouts/SeedsFertilizerLayout'),
    meta: { auth: true },
    children: childRoute('seeds_fertilizer_service.seeds-badc-configuration')
  }
]

export default routes
